/* =====================================================================
 * mediaNodes — 미디어 블록 TipTap Node 확장
 *   - ImageBlock, VideoBlock, AudioBlock, FileBlock, BookmarkBlock
 * ===================================================================== */

import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import {
  ImageBlockView,
  VideoBlockView,
  AudioBlockView,
  FileBlockView,
  BookmarkBlockView,
} from './MediaViews';

/* ── 공통 미디어 attrs ── */
const MEDIA_ATTRS = {
  src: { default: null as string | null },
  serverPath: { default: null as string | null },
  sessionId: { default: null as string | null },
  messageId: { default: null as string | null },
  fileName: { default: null as string | null },
  fileSize: { default: null as number | null },
  mimeType: { default: null as string | null },
  width: { default: null as number | null },
};

/* ================================================================== */
/* ImageBlock                                                          */
/* ================================================================== */

export const ImageBlock = Node.create({
  name: 'imageBlock',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return { ...MEDIA_ATTRS };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="image-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'image-block' })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageBlockView);
  },
});

/* ================================================================== */
/* VideoBlock                                                          */
/* ================================================================== */

export const VideoBlock = Node.create({
  name: 'videoBlock',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return { ...MEDIA_ATTRS };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="video-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'video-block' })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(VideoBlockView);
  },
});

/* ================================================================== */
/* AudioBlock                                                          */
/* ================================================================== */

export const AudioBlock = Node.create({
  name: 'audioBlock',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return { ...MEDIA_ATTRS };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="audio-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'audio-block' })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(AudioBlockView);
  },
});

/* ================================================================== */
/* FileBlock                                                           */
/* ================================================================== */

export const FileBlock = Node.create({
  name: 'fileBlock',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return { ...MEDIA_ATTRS };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="file-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'file-block' })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(FileBlockView);
  },
});

/* ================================================================== */
/* BookmarkBlock                                                       */
/* ================================================================== */

export const BookmarkBlock = Node.create({
  name: 'bookmarkBlock',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      url: { default: null as string | null },
      title: { default: null as string | null },
      description: { default: null as string | null },
      favicon: { default: null as string | null },
      image: { default: null as string | null },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="bookmark-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'bookmark-block' })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(BookmarkBlockView);
  },
});
